import React, { FC, useEffect } from 'react';

import { LandscapeProjectsAddProjectsContactInformationTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { useParams } from 'react-router-dom';
import Spinner from '../../atoms/Spinner/Spinner';
import {
  deleteLandscapeContactPerson,
  fetchLandscapeContactPersonByProjectId,
} from '../../../store/landscapeAPI/landscape/reducers/landscape-contact-person.slice';
import LandscapeProjectNotSavedInfoPage from '../LandscapeProjectNotSavedInfoPage';

interface LandscapeProjectsAddProjectsContactInformationPageProps {}

const LandscapeProjectsAddProjectsContactInformationPage: FC<
  LandscapeProjectsAddProjectsContactInformationPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { projectId } = useParams();

  const { landscapeContactPersons, status } = useSelector(
    (state: RootState) => state.landscapeContactPersonSlice
  );

  useEffect(() => {
    if (projectId && projectId !== 'new-project') {
      dispatch(fetchLandscapeContactPersonByProjectId(projectId));
    }
  }, [dispatch, projectId]);

  const handleDelete = async (id: string) => {
    await dispatch(deleteLandscapeContactPerson(id))
      .unwrap()
      .then(() => dispatch(fetchLandscapeContactPersonByProjectId(projectId!)));
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return projectId && projectId !== 'new-project' ? (
    <LandscapeProjectsAddProjectsContactInformationTemplate
      data={landscapeContactPersons ?? []}
      handleDelete={handleDelete}
    />
  ) : (
    <LandscapeProjectNotSavedInfoPage />
  );
};

export default LandscapeProjectsAddProjectsContactInformationPage;
